module.exports = __webpack_public_path__ + "9b1d9b848dbf4acdd71ae222857b931e.jpg";


//////////////////
// WEBPACK FOOTER
// ./2017-04-13-harrison/diary.jpg
// module id = 703
// module chunks = 0